import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import axios from 'axios';
import {config} from '../../common/config/config';
import {
    constance,
    WorkplaceInterface,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {styles} from '../../common/style';
import {Route, useNavigate} from 'react-router-dom';
import PostEditor from '../post/editor/PostEditor';
import TextField from '@mui/material/TextField';
import {MenuInterface} from "../../interface/menu.interface";
import {FormControl, FormControlLabel, FormLabel, MenuItem, MenuList, Paper, Radio, RadioGroup} from "@mui/material";
import ReactQuill from "react-quill";
import SelectDepartmentComponent from "../post/selectOption/SelectDepartmentComponent";
import {Club} from "../../interface/club.interface";
import {Department} from "../../interface/department.interface";
import {initClub, initDepartment} from "../../common/initState";
import SelectClubComponent from "../post/selectOption/SelectClubComponent";
import {User} from "../../interface/user.interface";
import {isMobile} from "react-device-detect";


interface State {
    type: string,
    userList: User[],
    receiver: User,
    receiverName: string,
    userListOpen: boolean
}

export default function NoteBoxSendNote() {
    console.log('[NoteBoxSendNote]');
    const [state, setState] = useState<State>({
        type: 'normal',
        userList: [],
        receiver: {
            _id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""
        },
        receiverName: '',
        userListOpen: false,
    });
    const QuillRef: any = useRef<ReactQuill>();
    const navigate = useNavigate();

    useEffect(() => {
        /* 사용자 리스트 가지고 오기 */
        axios.get(constance.api.getUserList).then((value) => {
            if (value.data.data) {
                for (let user of value.data.data) {
                    user.name = user.name.trim();
                    user.id = user.id.trim();
                    user.departmentName = user.departmentName !== null ? user.departmentName.trim() : '';
                    user.departmentCode = user.departmentCode.trim();
                }
                setState({
                    ...state,
                    userList: value.data.data,
                });
            }
        }).catch(reason => {
            alert(reason);
        });
    }, []);


    const handleTypeChange = (event: any) => {
        setState({
            ...state,
            type: event.target.value
        });
    };

    const handleReceiverChange = (event: any) => {
        setState({
            ...state,
            receiverName: event.target.value
        });
    };

    function handleOpenList() {
        setState({
            ...state,
            userListOpen: true,
            receiverName: '',
        });
    }


    function handleChangeReceiver(e: any, user: User) {
        let value = e.currentTarget.value;
        setState({
            ...state,
            userListOpen: false,
            receiver: user,
            receiverName: `${user.departmentName} ${user.name}`,
        });
    }


    function handleSaveNote() {
        let contents: any = QuillRef.current.value;
        if (state.receiver._id == '') {
            common.alert('받는사람을 선택해 주세요.', '', 'info');
            return;
        } else if (contents == '') {
            common.alert('내용을 입력해주세요.', '', 'info');
            return;
        } else if (state.type ==  '') {
            common.alert('종류를 선택해주세요.', '', 'info');
            return;
        }

        axios.post(constance.api.saveNote, {
            params: {
                receiver: state.receiver._id,
                type: state.type,
                content: contents
            }
        }).then(value => {
            if (value.data.success) {
                common.alert('쪽지 보내기 완료', '', 'info');
                navigate(`${config.url.noteBox}/${constance.noteType.sentInbox}`);
            } else {
                common.alert('쪽지 보내기 실패', '', 'error');
            }
            console.log(value);
        }).catch(reason => {
            console.log(reason);
        });
    }

    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";

    return (
        <>
            <Stack sx={{
                width: 1,
                maxWidth: config.maxWidth,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mt: 1
            }}>

                {/* 쪽지 종류 선택 */}
                <Box sx={{
                    width: 1,
                    display: 'flex',
                    justifyContent: 'flex-start', alignItems: 'center',
                    mt: 1,
                    mb: 1,
                    border: styles.border,
                    backgroundColor: 'var(--scc-surface)', borderRadius: 1,
                }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 1,
                        p: 2,
                        width: 100,
                        minWidth: 100,
                        backgroundColor: '#696969'
                    }}>
                        <Typography variant={fontSize} sx={{color: 'white'}}> 종류 </Typography>
                    </Box>
                    <Divider orientation={'vertical'} sx={{mr: 2}}/>
                    <Box sx={{display: 'flex', flexWrap: 'wrap', pt: 1, pb: 1}}>
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={state.type}
                                onChange={handleTypeChange}
                            >
                                <FormControlLabel value={constance.noteType.normal} control={<Radio/>} label="일반쪽지"/>
                                <FormControlLabel value={constance.noteType.appreciation} control={<Radio/>} label="감사카드"/>
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Box>

                {/* 받는사람*/}
                <Box sx={{
                    width: 1,
                    display: 'flex',
                    justifyContent: 'flex-start', alignItems: 'center',
                    mb: 1,
                    backgroundColor: 'var(--scc-surface)', borderRadius: 1,
                    position: 'relative',
                    height: 1,
                }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 1,
                        p: 2,
                        width: 100,
                        minWidth: 100,
                        backgroundColor: '#696969',
                        border: styles.border,
                        borderRight: '0px'
                    }}>
                        <Typography variant={fontSize} sx={{color: 'white'}}> 받는사람 </Typography>
                    </Box>
                    <Box id="ttt1" sx={{flexGrow: 1, height: 1, '.MuiOutlinedInput-root': {height: 1,}}}>
                        <TextField id="ttt"
                                   placeholder="받는사람 이름을 입력해주세요."
                                   value={state.receiverName}
                                   onClick={handleOpenList}
                                   onChange={(e) => handleReceiverChange(e)}
                                   label="" variant="outlined"
                                   sx={{width: 1, height: 1, backgroundColor: 'var(--scc-surface)', border: '0px', borderRadius: 1}}
                        />
                        <Paper sx={{
                            width: 320,
                            maxWidth: '100%',
                            position: 'absolute',
                            maxHeight: '400px',
                            overflowY: 'auto',
                            zIndex: 10,
                            display: state.userListOpen ? 'flex' : 'none',
                        }}>
                            <MenuList>
                                {
                                    state.userList.map((user, index) => {
                                        if (common.isEmpty(user.departmentName)) return;
                                        if (user.name == '이남주' && user.departmentName == '디자인팀') return;
                                        if (state.receiverName !== '') {
                                            if (user.name.indexOf(state.receiverName) == -1 && user.departmentName.indexOf(state.receiverName) ==
                                                -1) {
                                                return;
                                            }
                                        }
                                        return (
                                            <MenuItem value={user.id}
                                                      key={index}
                                                      onClick={(e) => handleChangeReceiver(e, user)}>
                                                <Typography variant={fontSize}>
                                                    {`${user.departmentName} ${user.name}`}
                                                </Typography>
                                            </MenuItem>
                                        );
                                    })
                                }

                            </MenuList>
                        </Paper>
                    </Box>

                </Box>

                {/* 에디터 */}
                <Box sx={{
                    width: 1,
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    background: 'var(--scc-surface)',
                    minHeight: 400,
                    '.ql-container' : {
                        height: isMobile? 'calc(100% - 68px)': 'calc(100% - 41px)'
                    },
                    '.ql-editor': state.type == constance.noteType.appreciation ? {
                        backgroundImage: 'url("/images/appreciation.png")',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                    } : {}
                }}>
                    <PostEditor readOnly={false} QuillRef={QuillRef} initContent={''}/>
                </Box>

                {/* 등록 */}
                <Box sx={{width: 1, mt: 2, display: 'flex', justifyContent: 'flex-end'}}>
                    <Button variant={'contained'}
                            color={'primary'}
                            onClick={handleSaveNote}
                    >
                        <Typography variant={fontSize}>보내기</Typography>
                    </Button>
                </Box>
            </Stack>
            <Box>

            </Box>
        </>
    );
}
